// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__JV6iQ","icon":"styles_icon__AZCor","title":"styles_title__vM0v2","description":"styles_description__Nbhli"};